import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import authStore from '@/stores/auth';
Vue.use(Vuex);

export const mainStore =  new Vuex.Store ({
  modules:{
    authStore
  },
  state: {
    count: 0,
    fakeData: [],

  },
  getters:{
    count: state => state.count,
    fakeData: state => state.fakeData,
  },
  mutations: {
    increment:(state,payload)=>{
       state.count+=payload;
    },
    decrement: state => state.count--,
    setList : (state,payload) => {
      state.fakeData = payload
    },
  },
  actions:{
    increment:({commit},payload)=>{
      commit('increment',payload)
    },
    decrement:({commit})=>{
      commit('decrement')
    },
    getData:({commit})=>{
      axios.get('https://jsonplaceholder.typicode.com/todos/')
      // axios.get('http://clients.inovacetech.com/inovace-client/api/v1/employee/profile/2051')
        .then(response=>{
           commit('setList',response.data)
        })
        .catch(error=>{
          console.log(error.response);
        });
    }
  }
});
